<template>
  <div>
    <v-card class="ma-1">
        <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-card
          :loading="isUploadingImage"
          elevation="0"
          class="mx-auto"
          max-width="150"
          @click="launchFilePicker()"
        >
          <v-avatar
            size="150px"
            v-ripple
            v-if="!selectedImageFile"
            class="grey lighten-3 mb-3"
          >
            <v-icon> mdi-plus-circle</v-icon>
          </v-avatar>
          <v-avatar size="150px" v-ripple v-else class="mb-3">
            <img :src="selectedImageUrl" alt="Image" />
          </v-avatar>
        </v-card>
      </v-card-text>
    </v-card>

    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept="image/*"
      @change="imageFileSelected($event.target.files)"
    />
  </div>
</template>

<script>
import { appBaseUrl } from "@/variables";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "ImageUploadComponent",

  //********************** */
  props: {
    title: {
      type: String,
      default: "",
    },
  },

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    selectedImageFile: null,
    selectedImageUrl: null,
    isUploadingImage: false,
    imageFileName: "",
  }),

  //********************** */
  computed: {
    ...mapGetters("Module", {
      propertyName: "propertyName",
    }),
  },

  //********************** */
  methods: {
    launchFilePicker: function () {
      this.$refs.uploader.click();
    },

    imageFileSelected: function (file) {
      let imageFile = file[0];
      console.log(imageFile);
      if (file.length > 0) {
        if (!imageFile.type.match("image.*")) {
          console.log("Error");
        } else {
          this.selectedImageFile = imageFile;
          let imageURL = URL.createObjectURL(imageFile);
          this.selectedImageUrl = imageURL;

          let token = window.localStorage.getItem("token") || "";

          const config = {
            headers: { Authorization: `Bearer ${token}` },
          };
          const url = `${appBaseUrl}/api/help/upload`;
          var self = this;

          this.isUploadingImage = true;

          var data = new FormData();
          data.append("logoImage", file[0]); //dropzone wraps the fileobject
          axios
            .post(url, data, config)
            .then(function (response) {
              self.imageFileName = self.statusHistory =
                response.data.fileName;
              self.isUploadingImage = false;
              //console.log(response);
              self.$emit('update:imageName', self.imageFileName);
            })
            .catch(function (error) {
              self.isUploadingImage = false;
              alert(error);
            });
        }
      }
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>